import $ from 'jquery';

var createMyPresent = {};

function setArticleQueryParam() {
    let queryParams = new URLSearchParams(window.location.search);
    if (this.dataset.articlecode) {
        queryParams.set('artikelcode', this.dataset.articlecode);
    }
    history.replaceState(null, null, '?' + queryParams.toString());
}

document.querySelectorAll('.product').forEach(variant => variant.addEventListener('click', setArticleQueryParam, false));

function bindEventListenerQueryParamsOnReRender() {
    document.querySelectorAll('.productsoortBox').forEach(variant => variant.addEventListener('click', setArticleQueryParam, false));
}

createMyPresent.init = function(hasPersonalizedGift = false, productId, uniqueId) {
    $('.customerForm').submit(function() {
        // allow the editor check to be disabled for product types without an editor
        var checkEditor = undefined;
        var checkEditorElement = $('#checkEditor');
        if(checkEditorElement.length && checkEditorElement.val() === 'false') {
            checkEditor = false;
        }

        return createMyPresent.couponSubmit(checkEditor);
    });

    createMyPresent.initValidation();

    $('.validated:input').blur(function() {
        $(this).validator.init(this);
    });

    $('.form-input').on('keyup paste change', function() {
        if ($(this).val()) {
            $(this).addClass('dirty');
        } else {
            $(this).removeClass('dirty');
        }
    });

    $('.form-input').each(function() {
        if ($(this).val()) {
            $(this).addClass('dirty');
        } else {
            $(this).removeClass('dirty');
        }
    });

    $('.validated:input').change(function() {
        $(this).validator.init(this);
    });

    $('.productgroupBox').on('click', function() {
        createMyPresent.hideOrderButton();
        $('.productgroupBox').removeClass('product--selected');
        $(this).addClass('product--selected');
        var coupon = $('#couponcode_span').html();
        var groupid = $(this).data('value');
        if(!$(this).hasClass("js-has-variants")){
            var articlecode = $('#group_' + groupid + '_article').html();
            $('#artikelcode').val(articlecode);
            var content_url = 'ajaxcontroller.php?req=content&couponcode=' + coupon + '&artikelcode=' + articlecode + '&groupid=' + groupid;
            createMyPresent.updateContent(content_url);
        } else {
            var articlecode = $('#artikelcode').val();
            var content_url = 'ajaxcontroller.php?req=content&couponcode=' + coupon + '&artikelcode=' + articlecode + '&groupid=' + groupid;
        }

        createMyPresent.updateContent(content_url);
    });

    createMyPresent.bindProductboxClick();
    createMyPresent.resizeProductsoortBox();

    if (hasPersonalizedGift) {
        var coupon = $('#couponcode_span').html();
        if ($('.productgroupBox.product--selected').length > 0) {
            var groupid = $('.productgroupBox.product--selected').data('value');
        } else {
            var groupid = $('#groupid').val();
        }
        var content_url = 'ajaxcontroller.php?req=content&couponcode=' + coupon + '&artikelcode='+ productId + '&groupid=' + groupid + '&uniqueid=' + uniqueId;
        createMyPresent.updateContent(content_url, false);
    }
};

createMyPresent.resizeProductsoortBox = function() {
    $(window).on("load resize orientationchange", function() {
        var maxHeight = Math.max.apply(null, $('.productsoortBox, .productsoortBoxSelected').map(function() {
            return $(this).height();
        }).get());
        $('.productsoortBox, .productsoortBoxSelected').css('min-height', maxHeight);
    }).resize();
};

createMyPresent.bindProductboxClick = function() {
    $('.productsoortBox').off('click');
    $('.productsoortBox').on('click', function() {
        createMyPresent.hideOrderButton();
        var coupon = $('#couponcode_span').html();
        var groupid = $('.productgroupBox.product--selected').data('value');
        var artikelcode = $('.artikelcode_box', this).attr('value');
        var productImage = $('.product-variant__image-src', this).attr('src');
        var productName = $('.product-variant__content-title', this).html();
        $('.product--selected .product-image').attr('src', productImage);
        $('.product--selected .product-name .product-name__current').html(productName);
        var content_url = 'ajaxcontroller.php?req=content&couponcode=' + coupon + '&artikelcode=' + artikelcode + '&groupid=' + groupid;
        createMyPresent.updateContent(content_url, false);
    });
};

createMyPresent.updateContent = function(url, renderSidebar = true) {
    $.ajax({
        url: url,
        success: function (data) {
            const response = JSON.parse(data);
            $('#product-meta').html(response.meta);
            $('#product-selector').html(response.selector);
            renderSidebar ? $('#product-selector').show() : $('#product-selector').hide();
            $('#product-information').html(response.info);
            $('#product-editor').html(response.editor);
            $('#product-order').html(response.order);
            createMyPresent.bindProductboxClick();
            createMyPresent.resizeProductsoortBox();
            createMyPresent.loadExampleImage();
            renderSidebar ? bindEventListenerQueryParamsOnReRender() : false;
        }
    });
};

createMyPresent.loadExampleImage = function() {
    if($('#previewServiceUrl').length) {
        var previewServiceUrl = $('#previewServiceUrl').attr('data-value');
        createMyPresent.showOrderButton();
        $.ajax({
            url: previewServiceUrl,
            success: function(data) {
                //Show first personalisation preview
                var previewImage = $(data).find('image:first');
                if(previewImage.length > 0) {
                    var previewImageUrl = $(previewImage).text();
                    $('#previewImage').attr('src', previewImageUrl);
                    $('#previewImageEditor').attr('src', previewImageUrl);
                    $('#previewImageOrder').attr('src', previewImageUrl);
                }
            },
            error: function(error) {
                console.log(error);
            }
        });
    }
};

createMyPresent.initValidation = function() {
    (function($) {
        $.fn.validator = {
            init:           function(o) {
                if(o.name === 'afz_titel') {
                    this.titel(o);
                }
                if(o.name === 'afz_voornaam' || o.name === 'naam') {
                    this.naam(o);
                }
                if(o.name === 'serienummer') {
                    this.serienummer(o);
                }
                if(o.name === 'artikelnummer') {
                    this.artikelnummer(o);
                }
                if(o.name === 'afz_achternaam') {
                    this.naam(o);
                }
                if(o.name === 'afz_land') {
                    this.postcode(o);
                }
                if(o.name === 'afz_email') {
                    this.email(o);
                }
                if(o.name === 'afz_straat') {
                    this.straat(o);
                }
                if(o.name === 'afz_huisnummer') {
                    this.huisnummer(o);
                }
                if(o.name === 'bedrijfsnaam') {
                    this.bedrijfsnaam(o);
                }
                if(o.name === 'kvknummer') {
                    this.kvknummer(o);
                }
                if(o.name === 'btwnummer') {
                    this.btwnummer(o);
                }
                if(o.name === 'afz_postcode') {
                    this.postcode(o);
                }
                if(o.name === 'afz_woonplaats') {
                    this.woonplaats(o);
                }
                if(o.name === 'afz_tel') {
                    this.telefoon(o);
                }
                if(o.name === 'ont_voornaam[]') {
                    this.naam(o);
                }
                if(o.name === 'ont_achternaam[]') {
                    this.naam(o);
                }
                if(o.name === 'ont_straat[]') {
                    this.straat(o);
                }
                if(o.name === 'ont_huisnummer[]') {
                    this.huisnummer(o);
                }
                if(o.name === 'ont_woonplaats[]') {
                    this.woonplaats(o);
                }
                if(o.name === 'ont_postcode[]') {
                    this.postcodeont(o);
                }
                if(o.name === 'ont_land[]') {
                    this.postcodeont(o);
                }
                if(o.name === 'ont_reactiemailadres[]') {
                    this.reactiemail(o);
                }
                if(o.name === 'ont_reactienaam[]') {
                    this.reactienaam(o);
                }
                if(o.name === 'ont_reactiebericht[]') {
                    this.reactiebericht(o);
                }
                if(o.name === 'birthdate') {
                    this.birthDate(o);
                }
                if(o.name === 'second_coupon_code') {
                    this.checkCouponCode(o);
                }
                if(o.name === 'activitynumber') {
                    this.activitynumber(o);
                }
            },
            titel:          function(o) {
                var leng = /[a-zA-Z0-9_.]{1,100}/;
                if(!o.value.match(leng)) {
                    doError(o, tr2_ww_naam_tekens);
                }
                else {
                    doSuccess(o);
                }
            },
            bedrijfsnaam:   function(o) {
                var leng = /[a-zA-Z0-9_.]{2,100}/;
                if($('input:radio[name=klanttype]:checked').val() == 'zakelijk') {
                    if(o.value.match(leng)) {
                        doSuccess(o);
                    }
                    else {
                        doError(o, tr2_ww_bedrijf_ongeldig);
                    }
                }
                else {
                    doSuccess(o);
                }
            },
            kvknummer:      function(o) {
                if($('input:radio[name=klanttype]:checked').val() == 'zakelijk') {
                    var leng = /[\w]{2,100}/;
                    if(!o.value.match(leng)) {
                        doError(o, tr2_ww_kvknummer_ongeldig);
                    }
                    else {
                        doSuccess(o);
                    }
                }
                else {
                    doSuccess(o);
                }
            },
            btwnummer:      function(o) {
                if($('input:radio[name=klanttype]:checked').val() == 'zakelijk') {
                    var leng = /[\w]{2,100}/;
                    if(!o.value.match(leng)) {
                        doError(o, tr2_ww_btwnummer_ongeldig);
                    }
                    else {
                        doSuccess(o);
                    }
                }
                else {
                    doSuccess(o);
                }
            },
            naam:           function(o) {
                var leng = /[a-zA-Z0-9_.]{2,100}/;
                if(!o.value.match(leng)) {
                    doError(o, tr2_ww_naam_tekens);
                }
                else {
                    doSuccess(o);
                }
            },
            serienummer:    function(o) {
                var leng = /[a-zA-Z0-9_.]{4,8}/;
                if(!o.value.match(leng)) {
                    doError(o, tr2_ww_serienummer_ongeldig);
                }
                else {
                    doSuccess(o);
                }
            },
            artikelnummer:  function(o) {
                var leng = /[a-zA-Z0-9_.-]{11,11}/;
                if(!o.value.match(leng)) {
                    doError(o, tr2_ww_artikelnummer_ongeldig);
                }
                else {
                    doSuccess(o);
                }
            },
            woonplaats:     function(o) {
                var leng = /[\w]{2,100}/;
                if(!o.value.match(leng)) {
                    doError(o, tr2_ww_plaats_tekens);
                }
                else {
                    doSuccess(o);
                }
            },
            email:          function(o) {
                var email = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
                if(o.value.match(email)) {
                    doSuccess(o);
                }
                else {
                    doError(o, tr2_ww_email_ongeldig);
                }
            },
            telefoon:       function(o) {
                var tel = /[a-zA-Z0-9_\.\-+()*#\s]{3,20}/;
                if(!o.value.match(tel)) {
                    doError(o, tr2_ww_telnr_ongeldig);
                }
                else {
                    doSuccess(o);
                }
            },
            straat:         function(o) {
                var straat = /[\w]{1,100}/;
                if(o.value.match(straat)) {
                    doSuccess(o);
                }
                else {
                    doError(o, tr2_ww_straat_ongeldig);
                }
            },
            postcode:       function(o) {
                var match = '';
                var fout = '';
                var land = $('#afz_land :selected').val();
                if(land === undefined) {
                    land = $('#afz_land').val();
                }
                if(land == 'NL') {
                    match = /^[1-9]{1}[0-9]{3}\s?[A-Z]{2}$/i;
                    fout = tr2_ww_errorpostcode_nl;
                }
                else if(land == 'BE' || land == 'AT' || land == 'CH') {
                    match = /^[1-9]{1}[0-9]{3}$/;
                    fout = tr2_ww_errorpostcode_be;
                }
                else if(land == 'DE') {
                    match = /^[0-9]{5}$/;
                    fout = tr2_ww_errorpostcode_de;
                }
                else if(land == 'FR') {
                    match = /^((F-)|(f-))?((2[A|B])|[0-9]{2})[0-9]{3}$/;
                    fout = tr2_ww_errorpostcode_fr;
                }
                else if(land == 'GB') {
                    match = /^([a-zA-Z]){1}([0-9][0-9]|[0-9]|[a-zA-Z][0-9][a-zA-Z]|[a-zA-Z][0-9][0-9]|[a-zA-Z][0-9]|[0-9][a-zA-Z]){1}([ ])([0-9][a-zA-z][a-zA-z]){1}$/;
                    fout = tr2_ww_errorpostcode_gb;
                }
                else if(land == 'US') {
                    match = /(^(?!0{5})(\d{5})(?!-?0{4})(-?\d{4})?$)/;
                    fout = tr2_ww_errorpostcode_us;
                }
                else {
                    match = /[1-9a-z ]/i;
                    fout = tr2_ww_errorpostcode;
                }
                if(o.name == 'afz_land') {
                    if(($('#afz_postcode').val()).match(match)) {
                        doSuccess(o);
                        $('#afz_postcode_msg').html('');
                        $('#afz_postcode').css('backgroundColor', '#DEF8CA');
                    }
                    else {
                        $('#afz_postcode').css('backgroundColor', '#ffebeb');
                        $('#afz_postcode_msg').html('<i class="icon-warning-sign error-icon icon-large"></i>' + fout);
                    }
                }
                else {
                    if(o.value.match(match)) {
                        doSuccess(o);
                    }
                    else {
                        doError(o, fout);
                    }
                }
            },
            postcodeont:    function(o) {
                var match = '';
                var fout = '';
                var uniqueid = '';
                if(o.name == 'ont_land[]') {
                    uniqueid = o.id.replace('ont_land', '');
                }
                else {
                    uniqueid = o.id.replace('ont_postcode', '');
                }
                var land = $('#ont_land' + uniqueid + ' :selected').val();
                if(land == 'NL') {
                    match = /^[1-9]{1}[0-9]{3}\s?[A-Z]{2}$/i;
                    fout = tr2_ww_errorpostcode_nl;
                }
                else if(land == 'BE' || land == 'AT' || land == 'CH') {
                    match = /^[1-9]{1}[0-9]{3}$/;
                    fout = tr2_ww_errorpostcode_be;
                }
                else if(land == 'DE') {
                    match = /^[0-9]{5}$/;
                    fout = tr2_ww_errorpostcode_de;
                }
                else if(land == 'FR') {
                    match = /^((F-)|(f-))?((2[A|B])|[0-9]{2})[0-9]{3}$/;
                    fout = tr2_ww_errorpostcode_fr;
                }
                else if(land == 'GB') {
                    match = /^([a-zA-Z]){1}([0-9][0-9]|[0-9]|[a-zA-Z][0-9][a-zA-Z]|[a-zA-Z][0-9][0-9]|[a-zA-Z][0-9]|[0-9][a-zA-Z]){1}([ ])([0-9][a-zA-z][a-zA-z]){1}$/;
                    fout = tr2_ww_errorpostcode_gb;
                }
                else if(land == 'US') {
                    match = /(^(?!0{5})(\d{5})(?!-?0{4})(-?\d{4})?$)/;
                    fout = tr2_ww_errorpostcode_us;
                }
                else {
                    match = /[1-9a-z ]/i;
                    fout = tr2_ww_errorpostcode;
                }
                if(o.name == 'ont_land[]') {
                    if(($('#ont_postcode' + uniqueid).val()).match(match)) {
                        doSuccess(o);
                        $('#ont_postcode' + uniqueid + '_msg').html('');
                        $('#ont_postcode' + uniqueid).css('backgroundColor', '#DEF8CA');
                    }
                    else {
                        $('#ont_postcode' + uniqueid).css('backgroundColor', '#ffebeb');
                        $('#ont_postcode' + uniqueid + '_msg').html('<i class="icon-warning-sign error-icon icon-large"></i>' + fout);
                    }
                }
                else {
                    if(o.value.match(match)) {
                        doSuccess(o);
                    }
                    else {
                        doError(o, fout);
                    }
                }
            },
            huisnummer:     function(o) {
                var huisnummer = /([0-9]{1})/;
                if(o.value.match(huisnummer)) {
                    doSuccess(o);
                }
                else {
                    doError(o, tr2_ww_huisnr_ongeldig);
                }
            },
            birthDate:      function(o) {
                var birthDate = /[0-9\-]{6,10}/;
                if(o.value.match(birthDate)) {
                    doSuccess(o);
                }
                else {
                    doError(o, tr2_ww_birthday_invalid);
                }
            },
            activitynumber: function(o) {
                var leng = /[a-zA-Z0-9]{9,15}/;
                if(!o.value.match(leng)) {
                    doError(o, createMyPresent.getEssentErrorString());
                }
                else {
                    doSuccess(o);
                }
            }
        };

        function doSuccess(o) {
            $('#' + o.id + '_msg').html('');
            // $('#' + o.id).css('backgroundColor', '#DEF8CA');
            $('#' + o.id).addClass('validated--success');
        }

        function doError(o, m) {
            // $('#' + o.id).css('backgroundColor', '#ffebeb');
            $('#' + o.id).addClass('validated--error');
            $('#' + o.id + '_msg').html('<i class="icon-warning-sign error-icon icon-large"></i>' + m);
        }
    })($);
};

createMyPresent.scrollToElement = function(el, min_px) {
    el = $('#' + el);
    if(el.length) {
        if(min_px > 0) {
            $('html,body').animate({scrollTop: el.offset().top - min_px}, 'slow');
        }
        else {
            $('html,body').animate({scrollTop: el.offset().top}, 'slow');
        }
    }
};

createMyPresent.onDataRequest = function() {
    var editor = $('#FabricEditor');
    if(editor) {
        $('#producteditor_loader').show();
        var response = editor.requestData();
        if(response !== 0) {
            var mess = 'Unknown Error';
            if(response === 1) {
                mess = '1, Data not ready';
            }
            console.error('ProductEditor responded with error code: ' + mess);
            $('#producteditor_loader').hide();
            return false;
        }
        else {
            return true;
        }
    }
    else {
        $('#producteditor_loader').hide();
        return false;
    }
};

createMyPresent.couponSubmit = function(checkEditor) {
    if(typeof checkEditor === 'undefined') {
        checkEditor = true;
    }

    if($('#layoutarea_ids').length > 0) {
        var pe = createMyPresent.onDataRequest();
        if(pe === true || !checkEditor) {
            $(':checked').each(function(i) {
                if($(this).hasClass('eigenadres')) {
                    id = $(this).attr('id');
                    var uniqueid = id.replace('eigenadres', '');
                }
            });
            $('.validated:input').each(function() {
                $(this).validator.init(this);
            });

            return !$('.icon-warning-sign.error-icon').length;
        }
        else {
            return false;
        }
    }
    else {
        $(':checked').each(function(i) {
            if($(this).hasClass('eigenadres')) {
                id = $(this).attr('id');
                var uniqueid = id.replace('eigenadres', '');
            }
        });
        $('.validated:input').each(function() {
            $(this).validator.init(this);
        });
        if($('.icon-warning-sign.error-icon').length > 0) {
            return false;
        }
        else {
            return true;
        }
    }
};

createMyPresent.getEssentErrorString = function() {
    var employeeIdError = "Ongeldig nummer, moet minimaal 9 tekens bevatten";
    var shopIdField = $('#essentShopId');
    if(shopIdField.length > 0) {
        if(shopIdField.attr('data-shop-id') == 87) { // FR
            employeeIdError = 'Numéro incorrect doit contenir au moins 9 caractères';
        }
    }
    return employeeIdError;
};

createMyPresent.hideOrderButton = function() {
    $('#orderButton').hide();
    $('#orderButtonTrans').show();
};

createMyPresent.showOrderButton = function() {
    $('#orderButton').show();
    $('#orderButtonTrans').hide();
};

export default createMyPresent;
